var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "nonzero",
    stroke: "#818181",
    strokeWidth: 0.5,
    d: "M3.047.49h6.945c.631 0 1.15.52 1.15 1.177v.973l2.57-1.652a.66.66 0 0 1 .677-.023c.226.113.361.362.361.611v5.748a.687.687 0 0 1-.36.61c-.226.114-.474.114-.677-.022L11.142 6.26v.973c0 .657-.519 1.177-1.15 1.177H3.047c-1.015 0-1.827-.837-1.827-1.878V2.368c0-1.04.812-1.878 1.827-1.878zm8.073 5.074l2.923 1.82a.212.212 0 0 0 .236 0 .25.25 0 0 0 .141-.228V1.4a.25.25 0 0 0-.141-.227c-.024 0-.071-.023-.118-.023s-.071 0-.118.046l-2.923 1.82v2.548zM1.88 6.672c0 .782.601 1.408 1.359 1.408h6.86a.7.7 0 0 0 .691-.715v-5.5a.7.7 0 0 0-.69-.715H3.238c-.758 0-1.359.626-1.359 1.408v4.114z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.30b8fa3f3cd33e64fbc49e69798843ab.svg";
export { ForwardRef as ReactComponent };